import React from "react";
import {
  tokens,
  makeStyles,
  Text,
  shorthands,
} from "@fluentui/react-components";
import { AboutSection } from "../../graphql/schema";

const useStyles = makeStyles({
  wrapper: {
    boxShadow: tokens.shadow8,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "650px",
    color: "white",
  },
  titleWraper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  hero: {
    position: "relative",
    zIndex: 1,
    minHeight: "15vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalXXXL
    ),
  },
});

type HeroAboutProps = {
  data: any;

};
export const HeroAbout = ({ data }: HeroAboutProps) => {
  const classes = useStyles();

  if(data === undefined) return <></>;
  const aboutSection: AboutSection = data?.aboutSection;

  return (
    <article
      className={classes.wrapper}
      style={{ position: "relative", overflow: "hidden", background: "black" }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `url(${aboutSection?.aboutHeroImage?.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          backgroundColor: "black",
        }}
      />

      <section className={classes.hero}>
        <div className={classes.text}>
          <div className={classes.titleWraper}>
            <Text size={900} align="center" weight="bold">
              {aboutSection?.aboutHeroTitle ?? ""}
            </Text>
          </div>
        </div>
      </section>
    </article>
  );
};
